import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import {
  readCookieConsent,
  writeCookieConsent,
  CONSENT_VERSION,
} from '@/utils/sitePrefsStorage'

/** Dev module URL must stay neutral (no privacy/cookie/consent in path) for strict filter lists. */
export const useCookieConsentStore = defineStore('sitePrefs', () => {
  const decided = ref(false)
  const analytics = ref(false)
  const thirdParty = ref(false)
  const bannerVisible = ref(false)
  const prefsModalOpen = ref(false)

  function hydrate() {
    const s = readCookieConsent()
    if (!s || !s.decided) {
      decided.value = false
      analytics.value = false
      thirdParty.value = false
      bannerVisible.value = true
      return
    }
    decided.value = true
    analytics.value = s.analytics
    thirdParty.value = s.thirdParty
    bannerVisible.value = false
  }

  function persist() {
    writeCookieConsent({
      v: CONSENT_VERSION,
      decided: true,
      analytics: analytics.value,
      thirdParty: thirdParty.value,
      updatedAt: Date.now(),
    })
    decided.value = true
    bannerVisible.value = false
  }

  function acceptAll() {
    analytics.value = true
    thirdParty.value = true
    persist()
  }

  function rejectNonEssential() {
    analytics.value = false
    thirdParty.value = false
    persist()
  }

  function saveCustom(a, t) {
    analytics.value = !!a
    thirdParty.value = !!t
    persist()
    prefsModalOpen.value = false
  }

  function openPrefs() {
    hydrate()
    prefsModalOpen.value = true
  }

  function closePrefs() {
    prefsModalOpen.value = false
  }

  hydrate()

  return {
    decided,
    analytics,
    thirdParty,
    bannerVisible,
    prefsModalOpen,
    acceptAll,
    rejectNonEssential,
    saveCustom,
    openPrefs,
    closePrefs,
    allowsAnalytics: computed(() => decided.value && analytics.value),
    allowsThirdParty: computed(() => decided.value && thirdParty.value),
  }
})
